import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataInput, IDepartments } from '../../../../interface/interfaces';

interface IInitialState {
    departmentsNetworkLoading: boolean;
    departmentsNetworkData: IDepartments[];
    departmentsNetworkError: string;
}

const initialState: IInitialState = {
    departmentsNetworkLoading: false,
    departmentsNetworkData: [],
    departmentsNetworkError: '',
};

const departmentsSlice = createSlice({
    name: 'departments',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchDepartmentsNetworkPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.departmentsNetworkLoading = true;
            state.departmentsNetworkData = [];
        },

        fetchDepartmentsNetworkFulfilled: (state: IInitialState, action: PayloadAction<IDepartments[]>) => {
            state.departmentsNetworkLoading = false;
            state.departmentsNetworkData = action.payload;
            state.departmentsNetworkError = '';
        },

        fetchDepartmentsNetworkFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.departmentsNetworkLoading = false;
            state.departmentsNetworkData = [];
            state.departmentsNetworkError = action.payload;
        },
    },
});

export default departmentsSlice.reducer;
export const { fetchDepartmentsNetworkPending, fetchDepartmentsNetworkFulfilled, fetchDepartmentsNetworkFailure } = departmentsSlice.actions;
